import axios from "axios";
import React from "react";
import Loader from "./loader";

class MainAbout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      images_big: "",
      images_1: "",
      images_2: "",
      aboutTitle: "",
      bannerText: "",
      description: "",
      visionTitle: "",
      visionText: "",
      missionTitle: "",
      missionText: "",
      services: "",
      siteLanguage: "",
      aboutList:[]
    };
  }

  componentDidMount() {
    const BackendUrl = process.env.REACT_APP_BACKEND_API_URL;
    const siteLanguage = localStorage.getItem("siteLanguage") || "en";
    this.setState.siteLanguage = siteLanguage;
    axios
      .post(`${BackendUrl}/about-us/multiple/1`)
      .then((response) => {
        const data = response.data.data[0];
        const goalSection = data.sections.find(
          (section) => section.type === "Our Goal"
        );
        const missionSection = data.sections.find(
          (section) => section.type === "Our Mission"
        );
        this.setState({
          aboutTitle: data.title[siteLanguage] || data.title.en,
          bannerText: data.title[siteLanguage] || data.title.en,
          images_big: data.images[0] || "",
          images_1: data.images[1] || "",
          // images_2: data.images[2] || '',
          description: data.description[siteLanguage] || data.description.en,
          visionImg:
            goalSection?.image || goalSection?.image,
          visionTitle:
            goalSection?.title[siteLanguage] || goalSection?.title.en,
          visionText:
            goalSection?.content[siteLanguage] || goalSection?.content.en,
          missionImg:
            missionSection?.image || missionSection?.title.en,
          missionTitle:
            missionSection?.title[siteLanguage] || missionSection?.title.en,
          missionText:
            missionSection?.content[siteLanguage] || missionSection?.content.en,
            
          aboutList: data.sections,
          loading: false,
        });
        
      })
      .catch((error) => {
        console.error("Language fetch failed:", error);
        this.setState({ loading: false });
      });
  }
  render() {
    // const {
    //   childImage,
    //   raisedAmount,
    //   additionalBannerText,
    //   services,
    //   buttonText,
    //   buttonUrl
    // } = this.props;
    const {
      loading,
      aboutTitle,
      images_big,
      images_1,
      // images_2,
      description,
      // bannerText,
      visionImg,
      visionTitle,
      visionText,
      missionImg,
      missionTitle,
      missionText,
      aboutList
      // services,
    } = this.state;

    if (loading) return <Loader />;

    return (
      <div
        className={`container-fluid about pt-3 ${
          this.setState.siteLanguage === "ur" ? " direction-rtl" : ""
        }`}
      >
        <div className="container">
          <h1 className="display-3 mb-3">
            {this.setState.siteLanguage === 'ur' ? 
              <><span className="text-primary">ہمارے بارے میں</span></> : 
              <><span className="text-primary">About Us</span></>
            }
            </h1>
          <div className="row g-5">
            <div className="col-xl-6">
              <div className="row g-4">
                <div className="col-6">
                  <img
                    src={images_big?.src}
                    alt={images_big?.name}
                    className="img-fluid h-100"
                  />
                </div>
                <div className="col-6">
                  <img
                    src={images_1?.src}
                    alt={images_1?.name}
                    className="img-fluid h-100 pb-0"
                  />
                  {/* <img src={images_2?.src} alt={images_2?.name} className="img-fluid pt-3 wow zoomIn" data-wow-delay="0.1s"/> */}
                </div>
              </div>
            </div>
            <div className="col-xl-6 ">
              <p className="fs-5 text-uppercase text-primary">{aboutTitle}</p>
              {/* <h1 className="display-6 pb-4 m-0">{bannerText}</h1> */}
              <p className="pb-4">{description}</p>
              <div className="row g-4">
                <div className="col-md-12">
                  <div className="ps-3 d-flex align-items-center justify-content-start">
                    {/* <span className="bg-primary btn-md-square rounded-circle mt-4 me-2">
                      <i className="fa fa-eye text-dark fa-4x mb-5 pb-2"></i>
                    </span> */}
                    <div className="about_img">
                      <img src={visionImg} alt={visionImg} className="img_primary"/>
                    </div>
                    <div className="mx-3">
                      <h5 className="text-primary">{visionTitle}</h5>
                      <p>{visionText}</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="ps-3 d-flex align-items-center justify-content-start">
                    <div className="about_img">
                      <img src={missionImg} alt={missionImg} className="img_primary"/>
                    </div>
                    <div className="mx-3">
                      <h5 className="text-primary">{missionTitle}</h5>
                      <p>{missionText}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row g-4 my-2">
            {aboutList.filter(activity => activity.type !== 'Our Goal' && activity.type !== 'Our Mission').map((activity, index) => (
              <div className="col-lg-6 col-xl-6" key={index}>
                <div className="activities-item  d-flex align-items-center flex-wrap flex-md-nowrap h-100">
                  <img src={activity?.image} alt={activity.image} className="img-fluid img_primary w-25" />
                  <div className="mx-2">
                    <h5 className="text-primary">{activity.title[this.setState.siteLanguage]}</h5>
                    <p className="">{activity.content[this.setState.siteLanguage]}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default MainAbout;
